// import external dependencies

import "jquery"

// Import everything from autoload
import "./autoload/_foundation.js"

jQuery(document).ready(() => {
	$('.hamburger-wrapper.open-menu').on('click', function () {
		$('.mobile-menu').toggleClass('active');
	})
	$('.hamburger-wrapper.close-menu').on('click', function () {
		$('.mobile-menu').removeClass('active');
	});

	if ($('.js-drilldown-back').length) {
		$('.js-drilldown-back').each(function () {
			$('.js-drilldown-back').find('a').text('Wstecz');
		});
	}

	$('.our-products__list-item .main-btn').hover( function(){
			$(this).closest('.our-products__list-item').addClass("hover");
		},
		function(){
			$(this).closest('.our-products__list-item').removeClass("hover");
		});
});



// WEBPACK FOOTER //
// ./scripts/main.js